export default __webpack_public_path__ + "assets/img/company-swiper01.png";